import { IconFolder, IconFolderOpen } from '@tabler/icons-react';

import { Props } from './DirectoryIcon.types';

const DirectoryIcon = ({ expanded }: Props) => {
  return expanded ? (
    <IconFolderOpen color="var(--mantine-color-yellow-9)" size={14} stroke={2.5} />
  ) : (
    <IconFolder color="var(--mantine-color-yellow-9)" size={14} stroke={2.5} />
  );
};

export default DirectoryIcon;
